module.exports = __webpack_public_path__ + "fb-tutorial-2-pl.png?c5cedf40b253e15583f477418ab2846e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/integrations/fb-tutorial-2-pl.png
// module id = hCzY
// module chunks = 50